<template>
    <v-container grid-list-md>
        <v-layout column class="card">
            <v-form ref="form">
                <v-layout row wrap>
                    <v-flex md6>
                        <v-label>Nome do perfil</v-label>
                        <v-text-field :rules="[rules.required]"
                                      v-input-filter="[filters.text]"
                                      v-uppercase
                                      maxlength="50"
                                      v-model="model.nome"
                                      flat
                                      solo>
                        </v-text-field>
                    </v-flex>

                    <v-flex md6>
                        <v-label>Usuários vinculados</v-label>
                        <autocomplete
                                placeholder="Selecione os usuários"
                                url="/admin/usuarios/autocomplete"
                                :params="params"
                                :items="usuarios"
                                v-model="model.usuarios_vinculados"
                                item-text="nome"
                                min-length="0"
                                item-value="id_usuario"
                                :rules="[rules.required]"
                                multiple chips>
                        </autocomplete>
                    </v-flex>
                </v-layout>

                <v-layout row mt-4>
                    <v-label>Permissões</v-label>
                </v-layout>

                <v-layout row wrap>
                   <v-flex md3>
                        <v-checkbox label="Regiões"  v-model="model.permissoes.permitir_cadastro_regiao"></v-checkbox>
                    </v-flex>

                    <v-flex md3>
                        <v-checkbox label="Usuários" v-model="model.permissoes.permitir_cadastro_usuario"></v-checkbox>
                    </v-flex>

                    <v-flex md3>
                        <v-checkbox label="Perfis" v-model="model.permissoes.permitir_cadastro_perfil"></v-checkbox>
                    </v-flex>
                    <v-flex md3>
                        <v-checkbox label="Comunicados" v-model="model.permissoes.permitir_cadastro_comunicado"></v-checkbox>
                    </v-flex>
                </v-layout>

                <v-layout row wrap>

                </v-layout>

                <v-layout row wrap>
                    <v-flex md3>
                        <v-checkbox label="Hierarquias" v-model="model.permissoes.permitir_cadastro_hierarquia"></v-checkbox>
                    </v-flex>

                    <v-flex md3>
                        <v-checkbox label="Unidades" v-model="model.permissoes.permitir_cadastro_unidades"></v-checkbox>
                    </v-flex>

                    <v-flex md3>
                        <v-checkbox label="Distribuição manual de leads" v-model="model.permissoes.permitir_cadastro_distribuicao_leads"></v-checkbox>
                    </v-flex>
                    <v-flex md3>
                        <v-checkbox label="Histórico de leads" v-model="model.permissoes.permitir_historico_leads"></v-checkbox>
                    </v-flex>
                </v-layout>

                <v-layout row wrap>
                    <v-flex md3>
                        <v-checkbox label="Expiração SLA" v-model="model.permissoes.permitir_configuracao_expiracao_sla"></v-checkbox>
                    </v-flex>
                    <v-flex md3>
                        <v-checkbox label="Remanejamento de leads" v-model="model.permissoes.permitir_remanejamento_leads"></v-checkbox>
                    </v-flex>
                    <v-flex md3>
                        <v-checkbox label="Definir mês comercial" v-model="model.permissoes.permitir_configuracao_mes_comercial"></v-checkbox>
                    </v-flex>
<!--                    <v-flex md3>-->
<!--                        <v-checkbox label="Gestão de vendas" v-model="model.permissoes.permitir_gestao_vendas"></v-checkbox>-->
<!--                    </v-flex>-->
                </v-layout>
                <v-layout row wrap>
                </v-layout>
            </v-form>
            <v-layout mt-3>
                <v-flex xs2>
                    <v-btn class="btn-default primary" @click="salvar">Salvar</v-btn>
                </v-flex>
            </v-layout>
        </v-layout>
    </v-container>
</template>

<script>
import Rules from '../plugins/validation'
import Filters from '../plugins/filters'
import { alert, error, sleep } from '@/plugins/helpers'
import { pick } from 'lodash'
import { mapMutations } from 'vuex'

const listagem = 'perfis'

export default {
  computed: {
    rules: () => Rules,
    filters: () => Filters,
    params () { return { id_unidade_negocio: this.$session.get('id_unidade_negocio') } }
  },
  data: () => {
    return ({
      edicao: false,
      usuarios: [],
      model: {
        id_perfil_usuario: null,
        nome: '',
        usuarios_vinculados: [],
        permissoes: {
          permitir_cadastro_regiao: false,
          permitir_cadastro_comunicado: false,
          permitir_historico_leads: false,
          permitir_cadastro_usuario: false,
          permitir_cadastro_hierarquia: false,
          permitir_cadastro_distribuicao_leads: false,
          permitir_cadastro_unidades: false,
          permitir_cadastro_perfil: false,
          permitir_configuracao_email: false,
          permitir_configuracao_expiracao_sla: false,
          permitir_gestao_vendas: false,
          permitir_remanejamento_leads: false,
          permitir_configuracao_mes_comercial: false
        }
      }
    })
  },
  methods: {
    ...mapMutations(['setPerfil']),
    salvar () {
      const form = this.$refs.form
      const edicao = this.model.id_perfil_usuario > 0
      const permissoes = this.model.permissoes
      this.model.id_unidade_negocio = this.$session.get('id_unidade_negocio')

      if (Object.values(permissoes).indexOf(true) !== -1) {
        if (form.validate()) {
          let req

          if (edicao) {
            req = this.$http.put(`/admin/perfis/${this.model.id_perfil_usuario}/permissoes`, this.model, {
              params: {
                id_usuario: this.$session.get('id_usuario')
              }
            })
          } else {
            req = this.$http.post('/admin/perfis/permissoes', this.model)
          }

          req.then(() => {
            alert({
              text: `Perfil ${edicao ? 'alterado' : 'cadastrado'} com sucesso!`,
              buttons: {
                'OK': () => { this.$router.push({ name: listagem }) }
              }
            })
            if (this.model.usuarios_vinculados.indexOf(this.$session.get('id_usuario')) !== -1) {
              this.$http.get(`/admin/perfis/hieraquia`)
                .then((r) => {
                  this.$session.set('painel_lead', this.model.permissoes.permitir_historico_leads)
                  if (r.data.superior) {
                    this.model.permissoes.permitir_cadastro_usuario = true
                    this.model.permissoes.permitir_cadastro_distribuicao_leads = true
                    this.model.permissoes.permitir_historico_leads = true
                  }
                  if (r.data.supervisor) {
                    this.model.permissoes.permitir_remanejamento_leads = true
                  }
                }).catch(this.fail)
              this.setPerfil(this.model.permissoes)
            }
          }).catch(err => {
            error(err, 'Não foi possível salvar as informações.')
          })
        } else {
          form.resetValidation()
          sleep(100).then(() => form.validate())
        }
      } else {
        alert('Selecione pelo menos um perfil.')
      }
    },
    loadPermissoes (id_perfil_usuario) {
      this.$http.get(`/admin/perfis/${id_perfil_usuario}/permissoes`)
        .then((r) => {
          this.model.permissoes = pick(r.data, Object.keys(this.model.permissoes))
          this.model.nome = r.data.nome_perfil
          this.model.id_perfil_usuario = r.data.id_perfil_usuario
          this.usuarios = r.data.usuarios

          r.data.usuarios.forEach(usuario => {
            this.model.usuarios_vinculados.push(usuario.id_usuario)
          })
        }).catch(this.fail)
    }
  },
  mounted () {
    const id_perfil_usuario = parseInt(this.$route.params['id_perfil_usuario'])

    if (id_perfil_usuario) {
      this.loadPermissoes(id_perfil_usuario)
    }
  }
}
</script>

<style scoped>

</style>
